import { lazyGetToCcRecipientsForReply } from 'owa-mail-compose-actions';
import Message from 'owa-service/lib/contract/Message';
import { lazyStartChat, StartChatSource } from 'owa-skype-for-business';

export default async function onReplyByImInternal(isReplyAll: boolean, message: Message) {
    const getAllRecipients = await lazyGetToCcRecipientsForReply.import();
    const [toRecipients, ccRecipients] = await getAllRecipients(message, isReplyAll);
    const allRecipients = [...toRecipients, ...ccRecipients].map(recipient => {
        return recipient.SipUri ? recipient.SipUri : 'sip:' + recipient.EmailAddress;
    });
    if (allRecipients.length > 0) {
        lazyStartChat
            .import()
            .then(startChat =>
                startChat(
                    allRecipients,
                    message.Subject,
                    isReplyAll ? StartChatSource.ReplyAllByIm : StartChatSource.ReplyByIm
                )
            );
    }
}
